import { render, staticRenderFns } from "./echartsCopy.vue?vue&type=template&id=3acd4fce&scoped=true"
import script from "./echartsCopy.vue?vue&type=script&lang=js"
export * from "./echartsCopy.vue?vue&type=script&lang=js"
import style0 from "./echartsCopy.vue?vue&type=style&index=0&id=3acd4fce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd4fce",
  null
  
)

export default component.exports